import React, { useEffect, useCallback, useState } from "react";

import {
    Box,
    Paper,
    Divider,
    TextField,
    Stack,
    Grid,
    Switch,
    FormControlLabel,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    Card,
    styled,
    ListItemText,
    ListItemButton,
    Collapse,
    List,
    ListItem,
    Typography,
    Chip,
    Button
} from '@mui/material';

import { grey } from "@mui/material/colors";
import { LoadingButton } from '@mui/lab';

import { useFormik } from 'formik';
import { useNavigate, useParams } from "react-router-dom";
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonRestricted from '../../common/CommonRestricted';
import { CommonIcons, icons } from "../../common/CommonIcons";

import { useAuthAccess } from "../../../hooks/useAuthAccess";
import { useRates, rateTypes, targetTypes as rateTargetTypes } from '../../../hooks/api/useRates';

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useAppContextFeatures } from '../../../context/AppContext';
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';
import { useTranslations } from "../../../hooks/useTranslations";

import { capitalizeString } from "../../../utils/formatString";

import { initialValues, validationSchema } from "../../../schema/rates/shipping/shippingRateSchema";

import AddNewArea from "./section/AddNewArea";
import ChangeDefault from "./section/ChangeDefault";

// import UpdateRateItem from "./section/UpdateRateItem";

import ActionConfirm from "../../dialog/ActionConfirm";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export default function UpdateShippingRate({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@rate"] })

    const { id } = useParams();

    const { promptMessage } = useSystemPrompt();
    const { isLoading, get, update, removeItem } = useRates({ rateType: rateTypes.shippingRate, targetType: rateTargetTypes.shippingRate });
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.rate.id, scopeTypes.rate.shippingRate.id)

    const { setSystemLoading, openCustomDrawer, closeCustomDrawer } = useAppContextFeatures();

    const navigate = useNavigate();
    const { authData, getAvailableLocations } = useAuthAccess();
    const availableLocations = getAvailableLocations();

    const [savedValues, setSavedValues] = useState()
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)
    const [open, setOpen] = useState(false);

    const [dataRateItems, setDataRateItems] = useState([])

    const [openCollapseNos, setOpenCollapseNos] = useState([])
    const [actionConfirmProps, setActionConfirmProps] = useState({
        open: false,
        title: ``,
        renderBody: () => { return <></> },
        handleConfirm: () => { }
    })

    const loadData = useCallback(async (id) => {

        setSystemLoading(true)

        try {

            const { data } = await get({ id })
            const { rate, items } = data;

            setSavedValues({
                rateName: rate.rate_name,
                locationId: rate.scope_id,
                description: rate.description,
                status: rate?.status === "1"
            })

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }, [id])

    const getSavedRate = useCallback(async (rateId) => {

        setSystemLoading(true)

        try {

            const { data } = await get({ id: rateId, dataTypesArray: ["rule"] })
            // const { shipping_rate: rate, items } = data;

            // setSavedValues({
            //     rateName: rate.rate_name,
            //     locationId: rate.scope_id,
            //     description: rate.description,
            //     status: rate?.status === "1"
            // })

            let rateItems = data?.items ? data.items : []

            // console.log('data', rateItems)

            setDataRateItems(rateItems)

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }, [id])

    const removeArea = async (areaIds = []) => {

        setSystemLoading(true)

        try {

            const response = await removeItem({ ids: areaIds })

            promptMessage(true, `${response?.message}`)

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }


    // const [ mainData, setMainData ] = useState(null)

    useEffect(() => {

        loadData(id);

        getSavedRate(id)

    }, [])

    const onSubmit = async (currentValues) => {

        try {

            let data = {
                rate: {
                    rate_name: currentValues?.rateName,
                    description: currentValues?.description,
                    status: currentValues?.status ? 1 : 0,
                }
            }
            const response = await update({ id, data });

            promptMessage(true, `${response?.message}`)
            navigate(getRoute("settings/shippingRates"))

        } catch (error) {
            promptMessage(false, `Action Failed. (${error?.message})`)
        }
    }

    const formik = useFormik({
        initialValues: savedValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, setFieldValue } = formik;

    const handleAddNewArea = ({ item, dataAreas = [] }) => {

        // if (!values) return false

        // console.log('item, item', item)

        let excludeAreaIds = dataAreas.map(i => i.scopeId)

        openCustomDrawer({
            show: true,
            anchor: "right",
            title: `${t('newAreaFor')} : ${item?.location_name}`,
            PaperProps: {
                sx: { width: 2 / 3 }
            },
            handleOnClose: () => { },
            ComponentActions:
                <></>,
            ComponentBody:
                <AddNewArea
                    routeType={routeType}
                    rateId={id}
                    stateId={item?.state_id}
                    stateName={item?.state_name}
                    locationId={item?.id}
                    locationName={item?.location_name}
                    excludeAreaIds={excludeAreaIds}
                    handleOnSuccess={() => {
                        closeCustomDrawer()
                        getSavedRate(id)
                        // fetchDataBranch(id)
                    }}
                />

        })

        return true;
    }

    const handleChangeDefault = (props) => {

        const {
            data,
            locationId,
            locationName
        } = props

        // console.log('data, item', data)

        openCustomDrawer({
            show: true,
            anchor: "right",
            title: `${t('changeDefaultMethodsFor')} : ${locationName}`,
            PaperProps: {
                sx: { width: 2 / 3 }
            },
            handleOnClose: () => { },
            ComponentActions:
                <></>,
            ComponentBody:
                <ChangeDefault
                    routeType={routeType}
                    rateId={id}
                    // stateId={item?.state_id}
                    // stateName={item?.state_name}
                    locationId={locationId}
                    locationName={locationName}
                    // excludeAreaIds={excludeAreaIds}
                    currentItems={data?.items ? data.items : []}
                    handleOnSuccess={() => {
                        closeCustomDrawer()
                        getSavedRate(id)
                        // fetchDataBranch(id)
                    }}
                />

        })

        return true;
    }

    const getScopesFromRateItems = ({ locationId }) => {

        // look for the saved Rate Items for this location id
        const selectedItems = dataRateItems.filter(i => i.to_location_id === locationId)

        // filter the area grouping
        // let areaIds = []
        let result = []

        selectedItems.forEach((i, index) => {

            const scopeId = i?.scope_id

            // check the scopeId Exists
            // const selected = result.filter((i) => i.scopeId === scopeId)
            let foundIndexNo = false;
            result.forEach((e1, index1) => {
                if (e1.scopeId === scopeId) {
                    foundIndexNo = index1
                }
            })

            // getting the rule Details
            const ruleDetail = i?.rules.length ? i.rules[0] : {}

            if (foundIndexNo !== false) { // if exists

                result[foundIndexNo].items.push({
                    id: i?.id,
                    ruleIds: i?.rule_ids,
                    measureType: i?.measure_type,
                    ruleDetails: ruleDetail
                })

            } else { // not exists - initial new entry
                result.push({
                    // key: index,
                    scopeId: i?.scope_id,
                    scopeType: i?.scope_type,
                    scopeName: i?.to_area_name,
                    stateName: i?.to_state_name,
                    locationId,
                    locationName: i?.to_location_name,
                    items: [
                        {
                            id: i?.id,
                            ruleIds: i?.rule_ids,
                            measureType: i?.measure_type,
                            ruleDetails: ruleDetail
                        }
                    ]
                })

            }

            // console.log('eeee -> ', result.length);

            // areaIds.push(scopeId)
            // return true;

        })

        return result;
    }

    const RenderFormLocation = () => {

        if (!values) return <></>

        return (
            <>
                <FormControl
                    margin="dense"
                    fullWidth
                    size="small"
                    error={touched.locationId && Boolean(errors.locationId)}
                >
                    <InputLabel id="location">{t("location")}</InputLabel>
                    <Select
                        disabled
                        labelId="locationId"
                        label={t("location")}
                        name={"locationId"}
                        onChange={(event) => {
                            setFieldValue(`locationId`, event.target.value)
                        }}
                        value={values.locationId ? values.locationId : ""}
                    >
                        {
                            availableLocations?.map((i, index) => {
                                return (
                                    <MenuItem key={index} value={i.id}>
                                        {/* <ListItemText 
                                                primary={`${i.location_name}`}
                                            /> */}
                                        {i.location_name}

                                    </MenuItem>
                                )
                            })
                        }
                    </Select>
                    <FormHelperText>
                        {touched.locationId && errors.locationId}
                    </FormHelperText>
                </FormControl>
            </>
        )
    }

    const RenderFormMain = () => {

        return (
            <>
                <StyledCard>
                    <Grid container spacing={0.5}>
                        <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                            <CommonSectionHeader
                                title={t('rateInfo')}
                                subTitle={t('detailsOfShippingRateInformation')}
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={9}>
                            <Grid container spacing={1}>
                                <Grid item xs={6}>
                                    <TextField
                                        margin="dense"
                                        size="small"
                                        autoFocus
                                        fullWidth
                                        name={"rateName"}
                                        label={t("rateName")}
                                        type="text"
                                        variant="outlined"
                                        value={values?.rateName}
                                        onChange={handleChange}
                                        error={touched.rateName && Boolean(errors.rateName)}
                                        helperText={touched.rateName && errors.rateName}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={6}>
                                    <FormControlLabel
                                        sx={{
                                            marginLeft: '1px'
                                        }}
                                        control={
                                            <Switch
                                                sx={{
                                                    mt: 1
                                                }}
                                                name="status"
                                                checked={Boolean(values.status)}
                                                onChange={(event, checked) => {
                                                    setFieldValue("status", checked);
                                                }}
                                            />
                                        }
                                        label={
                                            Boolean(values.status) ? t("enabled") : t("disabled")
                                        }
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={6}>
                                    {
                                        RenderFormLocation()
                                    }
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                        name={"description"}
                                        label={t("description")}
                                        type="text"
                                        variant="outlined"
                                        value={values?.description}
                                        onChange={handleChange}
                                        error={touched.description && Boolean(errors.description)}
                                        helperText={touched.description && errors.description}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </StyledCard>

                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        <LoadingButton
                            type="submit"
                            // fullWidth
                            variant="contained"
                            sx={{
                                mt: 1,
                                mb: 1
                            }}
                            loading={isLoading}
                        >
                            {t('saveChanges')}
                        </LoadingButton>
                    </Grid>
                </Grid>
            </>
        )
    }

    const actionClickCollapse = ({ index }) => {

        let saved = openCollapseNos

        // check index selected 
        const selected = saved.filter(i => i === index)

        // console.log('selected, selected', selected)

        // if existed
        if (selected.length > 0) {
            setOpenCollapseNos(saved.filter(i => i !== index))
        } else {
            setOpenCollapseNos(saved.concat(index))
        }

    }

    // Chip delete
    const handleAreaDelete = async ({ data }) => {
        // console.log("Clicked")
        // console.log('props', data)

        let ids = data?.items.map(i => i.id)

        await removeArea(ids)
        getSavedRate(id)

    }

    const RenderEmpty = () => {
        return (
            <Box
                sx={{
                    py: 3,
                    textAlign: 'center'
                }}
            >
                <Typography
                    sx={{
                        color: grey[500],
                        fontSize: 14
                    }}
                >
                    {t('empty')}
                </Typography>
            </Box>
        )
    }

    const RenderDefaultMethods = (props) => {

        const { data } = props

        // console.log('data --> ', data)

        const { items: ruleItems = [] } = data

        return (
            <Box>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={12} sm={12}>
                        <Typography
                            sx={{
                                fontWeight: '700'
                            }}
                        >
                            {t('defaultMeasureMethods')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                        {/* {
                            `${data?.items ? data.items.length : 0} Items`
                        }
                        {JSON.stringify(data)} */}
                        {
                            ruleItems.length <= 0 ?
                                (
                                    <RenderEmpty />
                                )
                                :
                                (
                                    ruleItems.map((i, index) => {
                                        return (
                                            <Chip
                                                key={i?.id}
                                                sx={{
                                                    mb: 1,
                                                    mr: 1
                                                }}
                                                label={
                                                    `${i?.ruleDetails?.rule_name} - ${i?.measureType ? capitalizeString({ val: i.measureType.toLowerCase() }) : '-'}`
                                                }
                                            />
                                        )
                                    })
                                )
                        }
                    </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                        <Button
                            fullWidth
                            variant="outlined"
                            onClick={() => {
                                handleChangeDefault(props)
                            }}
                        >
                            {t('changeDefault')}
                        </Button>
                    </Grid>
                </Grid>


                {/* {JSON.stringify(data)} */}

            </Box>
        )

    }

    const RenderRow = ({ index, item }) => {

        let currentIndex = openCollapseNos

        const locationId = item?.id
        const locationName = item?.location_name

        const dataForThisLocation = getScopesFromRateItems({ locationId })

        const dataAreas = dataForThisLocation.filter(i => i.scopeType !== "default")
        const dataLocation = dataForThisLocation.filter(i => i.scopeType === "default")

        return (
            <>
                <ListItem
                    disableGutters
                    disablePadding
                    divider
                >
                    <ListItemButton
                        sx={{
                            width: '100%',
                            px: 2,
                            // bgcolor: grey[100]
                        }}
                        onClick={() => {
                            // actionClickCollapse({ index: parseInt(index, 10) })
                            actionClickCollapse({ index: parseInt(index, 10) })
                        }}
                        disableGutters
                        selected={currentIndex.includes(index)}
                    >
                        <ListItemText
                            primary={
                                <Typography
                                    sx={{
                                        fontWeight: '800',
                                    }}
                                >
                                    {
                                        capitalizeString({ val: item?.location_name ? item.location_name : "-" })
                                    }

                                </Typography>
                            }
                        />
                        <Box
                            display={"flex"}
                            flexDirection={"row"}
                            justifyContent={"flex-end"}
                            alignItems={"center"}
                        >
                            {/* <Typography
                                sx={{
                                    fontWeight: '400',
                                    color: grey[500],
                                    mr: 1
                                }}
                            >
                                {
                                    `${totalAllowPermission} / ${totalPermissionCount}`
                                }
                            </Typography> */}
                            {
                                currentIndex.includes(index) ? <CommonIcons name={icons.chevronDown} /> : <CommonIcons name={icons.chevronUp} />
                            }
                        </Box>
                    </ListItemButton>


                </ListItem>
                <Collapse
                    in={currentIndex.includes(index)}
                    timeout="auto"
                    unmountOnExit
                >

                    <Box
                        sx={{
                            p: 2
                        }}
                    // display={"flex"}
                    // justifyContent={"space-between"}
                    // alignItems={"center"}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledCard>
                                    <RenderDefaultMethods
                                        locationId={locationId}
                                        locationName={locationName}
                                        data={dataLocation.length ? dataLocation[0] : []}
                                    />
                                </StyledCard>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <Box>
                                    {
                                        dataAreas.map((i, ind) => {
                                            return (
                                                <Chip
                                                    key={ind}
                                                    variant="outlined"
                                                    label={`${i.scopeName} ${i.items.length}`}
                                                    sx={{
                                                        mr: 1,
                                                        mb: 1
                                                    }}
                                                    onDelete={() => {

                                                        setActionConfirmProps({
                                                            ...actionConfirmProps,
                                                            open: true,
                                                            title: t(`removeAreaRuleItem`),
                                                            renderBody: () => {
                                                                return (
                                                                    <Typography>
                                                                        {t('areYouSureToDeleteThis')} {`${i?.scopeName} (${i?.stateName})`}?
                                                                    </Typography>
                                                                )
                                                            },
                                                            handleConfirm: () => {
                                                                handleAreaDelete({ data: i })
                                                            }
                                                        })

                                                    }}
                                                // onClick={() => handleUpdateRate()}
                                                />
                                            )
                                        })
                                    }
                                </Box>
                                <Box
                                    textAlign={"right"}
                                >
                                    <Button
                                        variant={"contained"}
                                        color={"primary"}
                                        onClick={() => {
                                            handleAddNewArea({ item, dataAreas })
                                        }}
                                    >
                                        <CommonIcons
                                            name={icons.plus}
                                            sx={{
                                                mr: 1
                                            }}
                                        />
                                        {t('addNewArea')}
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>

                    {/* <RenderPermissionRowCollapse
                        scope={scope}
                        target={scope?.target}
                    /> */}
                    {/* {
                        RenderPermissionRowCollapse({
                            scope,
                            target: scope?.target
                        })
                    } */}

                </Collapse>
            </>
        )
    }

    const RenderRateItemInfo = () => {

        return (
            <StyledCard>
                <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                    <CommonSectionHeader
                        title={t('locationAndAreaSettings')}
                        subTitle={t('selectAreaForUpdateThePriceForEachRulesApplication')}
                    />
                </Grid>

                {/* <Grid item xs={12} sm={12} md={9} textAlign={"left"}>

                        {
                            RenderArea()
                        }

                </Grid> */}

                <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                    {
                        availableLocations.map((item, index) => {
                            return (
                                <RenderRow
                                    key={index}
                                    index={index}
                                    item={item}
                                />
                                // <ListItemButton 
                                //     key={index} 
                                //     sx={{ 
                                //         pl: 4,
                                //      }}
                                // >
                                //     <ListItemText
                                //         primary={item.state_name}
                                //         onClick={() => handleAddNewArea()} 
                                //     />
                                // </ListItemButton>
                            )
                        })
                    }

                </Grid>
            </StyledCard>
        )
    }

    const RenderForm = () => {

        if (!values) return <></>

        return (
            <form onSubmit={formik.handleSubmit}>
                <Grid>
                    {
                        RenderFormMain()
                    }

                    {
                        RenderRateItemInfo()
                    }
                </Grid>
            </form>
        )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.updateRate })
            }

            <CommonBreadcumbs
                pageTitle={t("updateShippingRate")}
                breadcrumbs={[
                    {
                        displayText: t("shippingRates"),
                        props: {
                            href: getRoute("settings/shippingRates")
                        }
                    },
                    {
                        displayText: t("updateShippingRate"),
                        props: {
                            color: 'secondary.main'
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) ?
                    RenderForm()
                    :
                    <CommonRestricted />
            }

            <ActionConfirm
                open={actionConfirmProps.open}
                handleClose={() => setActionConfirmProps({ ...actionConfirmProps, open: false })}
                handleConfirm={() => {
                    actionConfirmProps.handleConfirm()
                    setActionConfirmProps({ ...actionConfirmProps, open: false })
                }}
                config={{
                    title: actionConfirmProps.title,
                    renderBody: actionConfirmProps.renderBody,
                    cancelButtonTitle: `Cancel`,
                    confirmButtonTitle: `Yes I've Confirmed`
                }}
            />

        </Box>
    )
}